import { render, staticRenderFns } from "./VendorResource.vue?vue&type=template&id=560ff629&"
import script from "./VendorResource.vue?vue&type=script&lang=js&"
export * from "./VendorResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports